export default "<h3>September 29, 2018</h3>\r\n<p>Update 0.32 fixes bugs.</p>";